/**
 * Feed chat author spans — used when the chat column is narrow so consecutive
 * messages from the same actor share one header instead of repeating avatars.
 */

/**
 * Chat column at or below this width uses compact (inline) author headers.
 *
 * Raised from 320 to 460 so the 3-column review layout (chat pane ≈ 30% of
 * the container) activates compact mode at typical screen widths (~1440px),
 * matching the "~1/3 screen width or less → compact" rule.
 */
export const FEED_COMPACT_AUTHOR_MAX_WIDTH_PX = 460;

/**
 * Stable author key for consecutive-span grouping in feed presentation.
 * Assistant turns share `"puntt"`; user turns key on `userId` (fallback `"user"`).
 */
export function feedMessageAuthorKey(message: {
  role: string;
  userId?: string | null;
}): string {
  if (message.role === "assistant") return "puntt";
  if (message.role === "user") {
    const id = message.userId?.trim();
    return id && id.length > 0 ? id : "user";
  }
  return message.role;
}

/** True when this message should show the author header (avatar + name). */
export function isFeedAuthorGroupStart(
  prevAuthorKey: string | null,
  authorKey: string,
): boolean {
  return prevAuthorKey == null || prevAuthorKey !== authorKey;
}
